export const industryData = [
  {
    industryCategory: "Manufacturing & Industrial",
    icon: "🏭",
    subCategories: [
      "Automobile & Auto Components",
      "Electrical & Electronics Manufacturing",
      "Consumer Durables / Home Appliances",
      "Heavy Engineering / Machinery",
      "Chemicals & Petrochemicals",
      "Plastics & Packaging",
      "Metals, Steel & Mining",
      "Cement & Construction Materials",
      "Textile & Garments",
      "Paper & Pulp",
      "Rubber & Tyres",
      "Industrial Equipment & Tools",
      
    ]
  },
  {
    industryCategory: "Real Estate & Infrastructure",
    icon: "🏢",
    subCategories: [
      "Residential Construction",
      "Commercial Real Estate",
      "Industrial Parks / Warehousing",
      "Smart Cities / Urban Infrastructure",
      "Roads, Highways & Bridges",
      "Power & Energy Infrastructure",
      "Ports & Airports Development",
      
    ]
  },
  {
    industryCategory: "Energy & Utilities",
    icon: "💡",
    subCategories: [
      "Power Generation (Thermal, Hydro, Nuclear)",
      "Renewable Energy (Solar, Wind, Biomass)",
      "Oil & Gas (Exploration, Refining, Distribution)",
      "Water Treatment & Waste Management",
      "Electricity Distribution & Smart Grids",
      
    ]
  },
  {
    industryCategory: "Services & Professional",
    icon: "🧑‍💼",
    subCategories: [
      "IT & ITES (Software, BPO, SAAS)",
      "Consulting (Management, HR, Strategy)",
      "Legal & Compliance Services",
      "Financial & Accounting Services",
      "Facility Management",
      "Security Services",
      
    ]
  },
  {
    industryCategory: "Banking, Financial Services & Insurance (BFSI)",
    icon: "🏦",
    subCategories: [
      "Public & Private Sector Banks",
      "NBFCs (Non-Banking Financial Companies)",
      "Mutual Funds & Asset Management",
      "Stockbroking & Investment Services",
      "Insurance (Life, Health, General, Reinsurance)",
      "Fintech & Payment Solutions",
      
    ]
  },
  {
    industryCategory: "Retail, FMCG & Consumer",
    icon: "🏬",
    subCategories: [
      "Food & Beverages (Packaged, Processed, Dairy)",
      "Personal Care & Household Products",
      "Apparel & Footwear",
      "Electronics & Gadgets",
      "Furniture & Home Improvement",
      "Supermarkets & Hypermarkets",
      "E-Commerce & D2C Brands",
      
    ]
  },
  {
    industryCategory: "Agriculture & Allied Industries",
    icon: "🚜",
    subCategories: [
      "Farming & Horticulture",
      "Agri Equipment & Irrigation",
      "Fertilizers & Pesticides",
      "Food Processing & Cold Chain",
      "Dairy, Poultry & Livestock",
      "Agri Tech Startups",
      
    ]
  },
  {
    industryCategory: "Logistics & Transportation",
    icon: "🚛",
    subCategories: [
      "Supply Chain Management",
      "Warehousing & Cold Storage",
      "Courier & Parcel Services",
      "Freight Forwarding",
      "Shipping & Ports",
      "Aviation (Cargo, Passenger)",
      "Rail & Metro Transport",
      
    ]
  },
  {
    industryCategory: "Healthcare & Life Sciences",
    icon: "🏥",
    subCategories: [
      "Hospitals & Clinics",
      "Pharmaceuticals",
      "Biotechnology",
      "Medical Devices",
      "Diagnostics & Pathology",
      "Health Insurance",
      "Telemedicine & HealthTech",
      
    ]
  },
  {
    industryCategory: "Education & Training",
    icon: "🎓",
    subCategories: [
      "International Schools",
      "CBSE Schools",
      "Metric Schools",
      "State Schools",
      "Colleges & Universities",
      "Coaching Institutes",
      "Vocational & Skill Development",
      "EdTech Platforms",
      "Professional Training Institutes",
      
    ]
  },
  {
    industryCategory: "Travel, Tourism & Hospitality",
    icon: "🏖️",
    subCategories: [
      "Hotels & Resorts",
      "Travel Agencies",
      "Tour Operators",
      "Airlines & Cruise Lines",
      "Restaurants & QSR Chains",
      "Event Management & MICE",
      
    ]
  },
  {
    industryCategory: "Media, Entertainment & Sports",
    icon: "🎥",
    subCategories: [
      "Television & Radio Broadcasting",
      "Film Production & OTT Platforms",
      "Advertising & Digital Marketing",
      "Gaming & Esports",
      "Sports Academies & Federations",
      "Publishing & Print Media",
      
    ]
  },
  {
    industryCategory: "Construction & Building Materials",
    icon: "🧱",
    subCategories: [
      "Builders & Developers",
      "Cement & Concrete",
      "Paints & Coatings",
      "Tiles, Sanitaryware & Fixtures",
      "Steel, Glass & Aluminum Products",
      "Interior Design & Architecture",
      
    ]
  },
  {
    industryCategory: "Environment & Sustainability",
    icon: "🌿",
    subCategories: [
      "Waste Recycling",
      "Green Energy Solutions",
      "Water Conservation",
      "Environmental Consultancy",
      "ESG & CSR Implementation",
      
    ]
  },
  {
    industryCategory: "Technology & Innovation",
    icon: "📱",
    subCategories: [
      "Software Development",
      "Artificial Intelligence & Machine Learning",
      "Internet of Things (IoT)",
      "Robotics & Automation",
      "Cloud Computing & Data Centers",
      "Cybersecurity",
      "Startups & Incubators",
      
    ]
  },
  {
    industryCategory: "Government & Public Sector",
    icon: "🪙",
    subCategories: [
      "PSUs (Public Sector Undertakings)",
      "Defence & Aerospace",
      "Railways & Transport Departments",
      "Municipal & Urban Development Bodies",
      "Smart City Projects",
      
    ]
  },
  {
    industryCategory: "Export & International Trade",
    icon: "🌏",
    subCategories: [
      "Export Houses",
      "Import Agents",
      "Trading Companies",
      "EPC (Export Promotion Councils)",
      "SEZ (Special Economic Zone) Units",
      
    ]
  },
  {
    industryCategory: "Real Estate & Housing",
    icon: "🏡",
    subCategories: [
      "Residential Projects",
      "Builders & Promoters",
      "Property Consultants",
      "Affordable Housing Projects",
      
    ]
  },
  {
    industryCategory: "Lifestyle & Luxury",
    icon: "💅",
    subCategories: [
      "Fashion & Designer Brands",
      "Luxury Automobiles",
      "Beauty & Wellness",
      "Jewellery & Accessories",
      "Fitness & Gyms",
      
    ]
  },
  {
    industryCategory: "Emerging & Future-Focused Sectors",
    icon: "🧬",
    subCategories: [
      "Electric Vehicles (EVs)",
      "Renewable Tech & Hydrogen Economy",
      "SpaceTech",
      "Agritech & FoodTech",
      "HealthTech",
      "CleanTech",
      "DeepTech Startups",
      
    ]
  }
];

// Sales Stages Data

export const salesStages = [
  {
    stageId: "S1",
    stageName: "Prospecting",
    probability: 0,
    activityGoal: "ASE/DE/CSE identifies and qualifies a potential lead",
    exitCriteria: "Contact accepts initial meeting/discovery call."
  },
  {
    stageId: "S2",
    stageName: "Qualification (Discovery)",
    probability: 20,
    activityGoal: "DE confirms problem fit, budget, authority, and timeline",
    exitCriteria: "Pain is quantified; key stakeholders are identified."
  },
  {
    stageId: "S3",
    stageName: "Deep Dive/Demo",
    probability: 40,
    activityGoal: "Tailored product demonstration focused on solving quantified pain points.",
    exitCriteria: "Champion confirms product fit and agrees to next-step workshop."
  },
  {
    stageId: "S4",
    stageName: "Solution Workshop & ROI",
    probability: 70,
    activityGoal: "Detailed technical scope is defined, and a formal ROI projection is created.",
    exitCriteria: "Client confirms scope is accurate and agrees to receive a proposal."
  },
  {
    stageId: "S5",
    stageName: "Proposal & Negotiation",
    probability: 90,
    activityGoal: "Formal commercial proposal and contract terms are presented.",
    exitCriteria: "Mutually agreed-upon closing date is set."
  },
  {
    stageId: "S6",
    stageName: "Closed-Won",
    probability: 100,
    activityGoal: "Contract signed and transition to Customer Success.",
    exitCriteria: "Contract fully executed."
  },
  {
    stageId: "S6",
    stageName: "Closed-Lost",
    probability: 0,
    activityGoal: "",
    exitCriteria: ""
  }
];

export const productCategories = [
  {
    productCategory: "Software",
    subCategories: [
      "Billing & Invoicing Software",
      "Accounting Software",
      "CRM Software",
      "ERP Systems",
      "Project Management Tools",
      "HR Management Software",
      "Inventory Management",
      "POS Systems",
      "Mobile App Development",
      "Custom Software Development",
      "SaaS Products",
      "Others - Mention that product"
    ]
  },
  {
    productCategory: "Marketing",
    subCategories: [
      "Social Media Management",
      "Digital Advertising",
      "SEO Services",
      "Content Marketing",
      "Email Marketing",
      "Brand Design & Identity",
      "Website Development",
      "Marketing Automation",
      "Influencer Marketing",
      "Video Marketing",
      "Print & Outdoor Advertising",
      "Market Research",
      "Public Relations",
      "Others - Mention that product"
    ]
  },
  {
    productCategory: "Website",
    subCategories: [
      "Corporate Website",
      "Business Website",
      "E-commerce Website",
      "Portfolio Website",
      "Landing Page",
      "Custom Web Application",
      "Website Redesign",
      "Website Maintenance",
      "Website Hosting",
      "Others - Mention that product"
    ]
  },
  {
    productCategory: "Personal Branding",
    subCategories: [
      "Personal Branding Strategy",
      "LinkedIn Profile Optimization",
      "Executive Branding",
      "Thought Leadership",
      "Content Creation",
      "Personal Website",
      "Portfolio Development",
      "Speaker Profile",
      "Media & PR",
      "Others - Mention that product"
    ]
  },
  {
    productCategory: "Google & Meta Ads",
    subCategories: [
      "Google Search Ads",
      "Google Display Ads",
      "Google Shopping Ads",
      "YouTube Ads",
      "Performance Max Campaigns",
      "Meta Facebook Ads",
      "Meta Instagram Ads",
      "Lead Generation Campaigns",
      "Remarketing Campaigns",
      "Campaign Management",
      "Others - Mention that product"
    ]
  },
  // {
  //   productCategory: "IT Infrastructure",
  //   subCategories: [
  //     "Cloud Services (AWS, Azure, GCP)",
  //     "Server & Storage Solutions",
  //     "Network Infrastructure",
  //     "Data Center Solutions",
  //     "Backup & Disaster Recovery",
  //     "IT Security Solutions",
  //     "Desktop & Laptop Systems",
  //     "Virtualization Solutions",
  //     "IT Support & Maintenance",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Business Services",
  //   subCategories: [
  //     "Consulting Services",
  //     "Legal Services",
  //     "Accounting & Bookkeeping",
  //     "Payroll Processing",
  //     "Recruitment & Staffing",
  //     "Training & Development",
  //     "Business Process Outsourcing",
  //     "Translation & Localization",
  //     "Virtual Assistant Services",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Communication Tools",
  //   subCategories: [
  //     "VoIP & Phone Systems",
  //     "Video Conferencing",
  //     "Team Collaboration Tools",
  //     "Instant Messaging",
  //     "Email Hosting",
  //     "Customer Support Software",
  //     "Chatbot Solutions",
  //     "Call Center Solutions",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Financial Services",
  //   subCategories: [
  //     "Payment Gateway",
  //     "Insurance Products",
  //     "Loan & Credit Services",
  //     "Investment Advisory",
  //     "Tax Consulting",
  //     "Financial Planning",
  //     "Expense Management",
  //     "Banking Solutions",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Security Solutions",
  //   subCategories: [
  //     "Cybersecurity Software",
  //     "Physical Security Systems",
  //     "CCTV & Surveillance",
  //     "Access Control Systems",
  //     "Fire & Safety Systems",
  //     "Data Protection Solutions",
  //     "Identity Management",
  //     "Security Consulting",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Analytics & Intelligence",
  //   subCategories: [
  //     "Business Intelligence Tools",
  //     "Data Analytics Software",
  //     "AI & Machine Learning Solutions",
  //     "Reporting & Dashboards",
  //     "Predictive Analytics",
  //     "Customer Analytics",
  //     "Market Intelligence",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "E-commerce Solutions",
  //   subCategories: [
  //     "E-commerce Platform",
  //     "Shopping Cart Software",
  //     "Payment Processing",
  //     "Inventory Management",
  //     "Shipping & Logistics",
  //     "Marketplace Integration",
  //     "Product Catalog Management",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Education & Training",
  //   subCategories: [
  //     "Learning Management Systems",
  //     "Online Course Platforms",
  //     "Corporate Training Programs",
  //     "Skill Development Courses",
  //     "Certification Programs",
  //     "Educational Content",
  //     "Virtual Classroom Solutions",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Healthcare Solutions",
  //   subCategories: [
  //     "Hospital Management Systems",
  //     "Electronic Health Records",
  //     "Telemedicine Platforms",
  //     "Medical Billing Software",
  //     "Pharmacy Management",
  //     "Diagnostic Software",
  //     "Health Insurance TPA",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Manufacturing & Industrial",
  //   subCategories: [
  //     "Industrial Machinery",
  //     "Automation Equipment",
  //     "Quality Control Systems",
  //     "Supply Chain Solutions",
  //     "Production Planning Software",
  //     "Maintenance Management",
  //     "Industrial IoT Solutions",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Real Estate & Construction",
  //   subCategories: [
  //     "Property Management Software",
  //     "Construction Management Tools",
  //     "Real Estate CRM",
  //     "Building Materials",
  //     "Architecture & Design Software",
  //     "Facility Management",
  //     "Property Listing Platforms",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Logistics & Transportation",
  //   subCategories: [
  //     "Fleet Management Systems",
  //     "Warehouse Management",
  //     "Transportation Management",
  //     "GPS Tracking Solutions",
  //     "Route Optimization",
  //     "Freight Management",
  //     "Last Mile Delivery Solutions",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Office & Productivity",
  //   subCategories: [
  //     "Office Furniture",
  //     "Stationery & Supplies",
  //     "Printing Solutions",
  //     "Document Management",
  //     "Time Tracking Software",
  //     "Productivity Tools",
  //     "Office Equipment",
  //     "Others - Mention that product"
  //   ]
  // },
  // {
  //   productCategory: "Others - Mention that category",
  //   subCategories: [
  //     "Others - Mention that product"
  //   ]
  // }
];


 // Format data for dropdowns
  export const visitTypeOptions = [
    { id: 'inPerson', label: 'In-Person' },
    { id: 'inBound', label: 'In-Bound' },
    { id: 'outBound', label: 'Out-Bound' },
  ];

  export const visitSubType = [
    { id: 'initial', label: 'Initial' },
    { id: 'followUp', label: 'Follow-Up' },
  ];

  export const sourceTypeOptions = [
    // Digital / Search
    { id: 'google', label: 'Google Search / Website' },
    { id: 'googleMaps', label: 'Google Maps / GMB' },
    
    // Social Media
    { id: 'facebook', label: 'Facebook' },
    { id: 'instagram', label: 'Instagram' },
    { id: 'linkedIn', label: 'LinkedIn' },
    { id: 'whatsapp', label: 'WhatsApp' },
    { id: 'youtube', label: 'YouTube' },
    { id: 'twitter', label: 'X (Twitter)' },

    // B2B Platforms
    { id: 'justdial', label: 'Justdial' },
    { id: 'indiamart', label: 'IndiaMART' },

    // Direct Outreach
    { id: 'coldCall', label: 'Cold Call' },
    { id: 'coldEmail', label: 'Cold Email' },
    { id: 'fieldVisit', label: 'Direct Field Visit' },

    // Events & Networking
    { id: 'expo', label: 'Expo / Exhibition' }, // Keeps your logic active
    { id: 'referral', label: 'Referral / Word of Mouth' },
    { id: 'newspaper', label: 'Newspaper / Magazine' },

    { id: 'influencer', label: 'Influencer' },
    
    // Others
    { id: 'others', label: 'Others' }
  ];

  export const currencyOptions = [
    { id: 'INR', label: 'INR (₹)' },
    { id: 'USD', label: 'USD ($)' },
    { id: 'EUR', label: 'EUR (€)' },
    { id: 'GBP', label: 'GBP (£)' }
  ];

  export const paymentStatusOptions = [
    { id: 'na', label: 'N/A' },
    { id: 'pending', label: 'Pending' },
    { id: 'partial', label: 'Partial' },
    { id: 'completed', label: 'Completed' }
  ];

  export const professionOptions = [
    { id: 'Salaried / Private Employee', label: 'Salaried / IT & Private' },
    { id: 'Business / Entrepreneur', label: 'Business Owner / Entrepreneur' },
    { id: 'Government Employee', label: 'Government / Public Sector' },
    { id: 'Professional (Doctor / Lawyer / CA)', label: 'Professional (Doctor, Lawyer, CA)' },
    { id: 'Self-Employed / Freelancer', label: 'Self-Employed / Freelancer' },
    { id: 'Student', label: 'Student' },
    { id: 'Homemaker', label: 'Homemaker / Parent' },
    { id: 'Others', label: 'Others' }
  ];

 export const annualTurnoverOptions = [
  { id: 'Below 25L', label: 'Below ₹25 Lakhs' },
  { id: '25L - 50L', label: '₹25L - ₹50 Lakhs' },
  { id: '50L - 1Cr', label: '₹50L - ₹1 Crore' },
  { id: '1Cr - 5Cr', label: '₹1Cr - ₹5 Crores' },
  { id: '5Cr - 10Cr', label: '₹5Cr - ₹10 Crores' },
  { id: 'Above 10Cr', label: 'Above ₹10 Crores' },
];

export const registrationOptions = [
  { id: 'unregistered', label: 'Unregistered Business' },
  { id: 'registered', label: 'Registered Business' },
];

export const taxTypeOptions = [
  { id: 'gst', label: 'GST (Goods & Services Tax)' },
  { id: 'vat', label: 'VAT' },
  { id: 'salesTax', label: 'Sales Tax' },
];

export const partnerTypeOptions = [
  { id: 'Direct Customer', label: 'Direct Customer' },
  { id: 'Reseller', label: 'Reseller / Dealer' },
  { id: 'System Integrator', label: 'System Integrator' },
  { id: 'Referral Partner', label: 'Referral Partner' },
];